<div class="container">
  <mat-card>
    <form [formGroup]="provisioningEntryForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field class="flex-fill" (click)="datePicker.open()">
            <mat-label>{{ 'labels.inputs.Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="datePicker"
              required
              formControlName="date"
            />
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
            @if (provisioningEntryForm.controls.date.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <div class="flex-fill">
            <mat-checkbox labelPosition="before" formControlName="createjournalentries">
              {{ 'labels.inputs.Create Journal Entries' | translate }}
            </mat-checkbox>
          </div>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!provisioningEntryForm.valid"
          *LOSxHasPermission="'CREATE_PROVISIONING_ENTRIES'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
